export enum eKioskError {
    OK = 0,
    STARTED = 1000,
    CONTRACT_NOT_KNOWN = 4000,
    CONTRACT_NOT_YET_VALID = 4010,
    CONTRACT_EXPIRED = 4020,
    CONTRACT_BLOCKED = 4021,
    PREHOSPI_EXISTS = 4022,
    INSURER_NO_ACTIVE_QUESTIONNAIRE= 4030,
    WRONG_BIRTHDATE= 4040,
    HOSPITALISATION_REGISTER_ERROR= 4050,
    INSURER_KIOSK_NOT_ALLOWED= 4060,
    INSURER_HOME_NOT_ALLOWED= 4070,
    ADMISSION_DATE_INTERVAL_ERROR= 4080,
    TECHNICAL_ERROR= 9999,
    INTERHOSPI_DELAY_ERROR = 9998,
}
export enum ePrintingStatus {
    PRITING,
    BUSY,
    ERROR,
    COMPLETE
}